import React from 'react'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import { PathValidationErrorTag } from '#src/generated/graphql'
import { Link } from 'react-router-dom'
import { Notification } from '@deal/components'
import { usePathContext } from '../../PathContext'
import { loginLocation } from '#src/services/routing'
import styles from './styles.css'

interface ErrorTagsProps {
  tags: PathValidationErrorTag[]
}

const ErrorTags: React.SFC<ErrorTagsProps> = ({ tags }) => {
  const pathContext = usePathContext()

  return (
    <>
      {tags.map((tag: string, idx: number) => {
        switch (tag) {
          case PathValidationErrorTag.REQUIRES_LOGIN_TO_PROCEED:
            return (
              <Link
                to={loginLocation({
                  pathname: `/requests/reenter/${pathContext.pathFlow.slug}/${pathContext.pathFlowPage.slug}`,
                  search: `?flowId=${pathContext.pathFlow.id}`,
                  state: {},
                  hash: ''
                })}
                key={idx}
                className={styles.logIn}
              >
                Log in here.
              </Link>
            )

          default:
            return null
        }
      })}
    </>
  )
}

const ErrorHeader: React.SFC = () => {
  const pathContext = usePathContext()

  const pageErrors = pathContext.pageErrors

  return (
    <>
      {pageErrors.length > 0 &&
        pageErrors.map((error, idx: number) => {
          return (
            <div data-testid="error-header" key={idx}>
              <Notification type="error" className={styles.notifications}>
                {error.message && <AttributedHtmlText text={error.message} />}
                {error.tags && error.tags.length > 0 && <ErrorTags tags={error.tags} />}
              </Notification>
            </div>
          )
        })}
    </>
  )
}

export default ErrorHeader
